import { formatMoney as format } from 'accounting'

export function formatMoney(obj, multiplier = 1) {
  const amount = (obj.amount * multiplier) / 100
  return format(amount, {
    symbol: obj.symbol || '€',
    decimal: obj.decimalSeparator || ',',
    thousand: obj.thousandSeparator || '.',
    precision: obj.precision || 2,
    format: obj.symbolPlacement === 'AFTER' ? '%v%s' : '%s%v',
  })
}
